module.exports = __webpack_public_path__ + "static/media/correct.d6f34353.svg";